/*
 * @Description: 
 * @Author: pliybird
 * @Date: 2022-01-26 01:25:38
 * @LastEditTime: 2023-07-13 21:40:32
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
import { login } from "./api";
export default class AppFunctions {
    static addClass(element, className) {
        document.querySelector(element).classList.add(className)
    }

    static removeClass(element, className) {
        document.querySelector(element).classList.remove(className)
    }

    static toggleClass(element, className) {
        document.querySelector(element).classList.toggle(className)
    }

    static flatDeep(arr, d = 1) {
        return d > 0 ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? this.flatDeep(val, d - 1) : val), []) : arr.slice();
    }

    static slugify(text) {
        return text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w-]+/g, '') // Remove all non-word chars
            .replace(/--+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '') // Trim - from end of text
    }

    static containsObject(obj, list) {
        let i;
        for (i = 0; i < list.length; i++) {
            if (list[i].slug === obj.slug) {
                return i;
            }
        }

        return -1;
    }
    /**
     * @description: 登录接口，获取token或者刷新token
     * @param {*} grant_type
     * @param {*} client_id 客户端id
     * @param {*} client_secret
     * @param {*} Username 
     * @param {*} Password
     * @return {*} 返回token
     */
    static refreshToken() {
        // let params = {
        //     "grant_type": "password",
        //     "client_id": "client",
        //     "client_secret": "secret",
        //     "Username": "test01",
        //     "Password": "H@nd123$"
        // }
        let params = {
            "grant_type": "client_credentials",
            "client_id": "ad3e3714-c693-4ac5-a0ab-ec70e9c0644a",
            "client_secret": "5MU.Jfe~1VF5k4Vfzz_jom2~bu_9HUYLo",
        }
        return login(params).then(res => {
            const token = res.access_token;
            console.log("env", process.env)
            // 更新 localStorage 中的 token
            localStorage.setItem('token', token);
            return token;
        });
    }

}